import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AddExceptionInputData, AddExceptionModalComponent, AddExceptionOutputData } from 'app/components/content-layers/add-exception-modal/add-exception-modal.component';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { DomainService, GivColumnDomain } from 'app/services/domain.service';
import { LayerCategoryStandardSchema } from 'app/services/field-mapping.service';
import { FlipRoadService } from 'app/services/flip-road.service';
import { QaResolverFeed, RCRecordItem, ResoCenterCol, ResoCenterRule, ResolutionCenterService } from 'app/services/resolution-center.service';
import { Subscription } from 'rxjs';
import { RCCellChangeData } from '../rc-cell/rc-cell.component';

interface ResoCenterColExt extends ResoCenterCol {
	leftRight: 'l' | 'r';
	fromTo?: 'from' | 'to';

	neutralProp: string; // left/right should be same
	neutralLabel?: string

	isTransposable?: boolean;
}

@Component({
  selector: 'app-resolution-aoe',
  templateUrl: './resolution-aoe.component.html',
  styleUrls: ['./resolution-aoe.component.css', '../resolution-inspector/resolution-inspector.component.css']
})
export class ResolutionAOEComponent implements OnInit, OnChanges, OnDestroy {

	@Input()resolverFeed: QaResolverFeed;

	@Output() edit: EventEmitter<any> = new EventEmitter();

	centerline: RCRecordItem;

	leftCols: ResoCenterColExt[];
	rightCols: ResoCenterColExt[];
	rules: ResoCenterRule[] = [];

	isFlipRoadGeom = false;

	transposeCheckALl: boolean;

	metricsInfo: {
		leftCols: ResoCenterColExt[];
		rightCols: ResoCenterColExt[];
		props: {
			[prop: string]: any;
		};
	}

	domainsByColumn: {
		[prop: string]: GivColumnDomain;
	} = {};

	private flipRoadSub: Subscription;

	constructor(
		private elemRef: ElementRef,
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private domainService: DomainService,
		private flipRoadService: FlipRoadService,
		private modalService: CommonModalService,
		private resoCenterService: ResolutionCenterService
	) { }
	
	toggleTransposeCheckAll() {
		this.leftCols.forEach(c => c.isTransposable = this.transposeCheckALl);
		this.rightCols.forEach(c => c.isTransposable = this.transposeCheckALl);
	}

	switchUpDown(direction: 'left' | 'right') {
		const cols = direction === 'left' ? this.leftCols : this.rightCols;
		const fromCol = cols.find(c => c.fromTo === 'from');
		const toCol = cols.find(c => c.fromTo === 'to');
		if (!fromCol || !toCol) {
			return;
		}
		const temp = this.centerline.props[fromCol.prop];
		this.centerline.props[fromCol.prop] = this.centerline.props[toCol.prop];
		this.centerline.props[toCol.prop] = temp;
		this.resoCenterService.onEditRecord(this.centerline, fromCol);
		this.resoCenterService.onEditRecord(this.centerline, toCol);
		this.checkDensityChange(fromCol);

		this.edit.emit({
			changedCols: [fromCol, toCol]
		});
	}
	switchLeftRight() {
		this.leftCols.forEach(c => {
			if (!c.isTransposable) {
				return;
			}
			const temp = this.centerline.props[c.prop];
			const rightCol = this.rightCols.find(rc => rc.neutralProp === c.neutralProp);
			if (rightCol) {
				this.centerline.props[c.prop] = this.centerline.props[rightCol.prop];
				this.centerline.props[rightCol.prop] = temp;
				//
				this.resoCenterService.onEditRecord(this.centerline, c);
				this.resoCenterService.onEditRecord(this.centerline, rightCol);
			}
		});
		this.setMetricsValue();

		this.edit.emit({
			changedCols: this.leftCols.concat(this.rightCols)
		});
	}
	// flipRoad() {
	// 	this.isFlipRoad = !this.isFlipRoad;
	// 	// this.activityService.flipRoadSubject.next({
	// 	// 	// id: this.centerline.id
	// 	// });
	// 	this.onEditCell(null, true);
	// }
	onEditCell(changedCol: ResoCenterCol, isGeomChange?: boolean) {
	// onEditCell(changedCol: ResoCenterCol, isGeomChange?: boolean) {
		this.resoCenterService.onEditRecord(this.centerline, changedCol, isGeomChange);
		this.checkDensityChange(changedCol);

		this.edit.emit({
			changedCols: changedCol ? [changedCol] : []
		});
	}

	async clickExcept() {
		// const layer = this.selectedLayer;
		// if (layer.isFishbone === true) {
		// 	return;
		// }
		// if (!i.row) {
		// 	this.toastr.info('Please select a record');
		// 	return;
		// }
		// const data: AddExceptionInputData = {
		// 	column: i.column,
		// 	qaNotes: i.row[this.qaNotesColName],
		// 	record: i.row
		// };
		// const rsp: AddExceptionOutputData = await this.modalService.openModalWindow(AddExceptionModalComponent, {
		// 	data: data,
		// 	width: '600px',
		// 	height: '350px'
		// });
		// if (rsp) {
		// 	const exceptions = rsp.exceptions;
		// 	const uuid = this.getRecordId(rsp.record);
		// 	const promises = exceptions.map(e => this.exceptionService.addException(layer.id, uuid, e.colName, e.gqrCode, e.reason));
		// 	await Promise.all(promises).then(async () => {
		// 		this.toastr.success('Successfully added.');
		// 		await this.getExceptionsForRec(i.row, true);
		// 		// Select exception tab
		// 		const idx = this.tabs.findIndex(t => t.key === 'exception');
		// 		if (idx > -1 && !this.tabs[idx].hidden) {
		// 			this.verticalTabsComp.selectTab(idx);
		// 		}
		// 	})
		// 	.catch(err => {
		// 		this.toastr.error(err.message);
		// 	});
		// }
	}

	private async onFeedChange() {
		this.resetMetrics();
		if (!this.resolverFeed) {
			this.rightCols = [];
			this.rules = [];
			return;
		}
		const layerCateCode = Object.keys(this.resolverFeed.feed)[0];
		const cols = await this.resoCenterService.transformCols(this.resolverFeed.feed[layerCateCode].cols, layerCateCode);
		const centerlineList = await this.resoCenterService.transformItemList(this.resolverFeed, layerCateCode);
		this.centerline = centerlineList[0];
		//
		const separates = this.separateColLeftRight(cols);
		this.leftCols = separates.leftCols;
		this.rightCols = separates.rightCols;
		// Default: first 3 transposable checked
		if (this.leftCols.length >= 3) {
			for (let i = 0; i < 3; i++) {
				this.leftCols[i].isTransposable = true;
			}
		}
			// this.transposeCheckALl = true;
			// this.toggleTransposeCheckAll();
		// Metrics
		const metricsColsInfo = this.resolverFeed.feed[layerCateCode].metrics;
		if (metricsColsInfo) {
			const metricsCols = await this.resoCenterService.transformCols(metricsColsInfo, layerCateCode);
			const metricsSeparates = this.separateColLeftRight(metricsCols);
			this.metricsInfo.leftCols = metricsSeparates.leftCols;
			this.metricsInfo.rightCols = metricsSeparates.rightCols;
			this.setMetricsValue();
		}
	
		this.rules = this.resoCenterService.transformRules(this.resolverFeed.rules);

		// Domain
		const layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
		const colsForDomain: {prop; standard: LayerCategoryStandardSchema}[] = cols.map(c => {
			return {
				prop: c.prop,
				standard: layerCate.standardCols.find(s => s.colName === c.standardName)
			}
		});
		this.domainsByColumn = this.domainService.getColumnDomains(colsForDomain, layerCate.code, this.centerline.props);

	}
	private separateColLeftRight(cols: ResoCenterCol[]) {
		const leftCols: ResoCenterColExt[] = [];
		const rightCols: ResoCenterColExt[] = [];
		// Separate left cols and right cols
		cols.forEach(c => {
			const col: ResoCenterColExt = {
				prop: c.prop,
				label: c.label,
				lbType: c.lbType,
				standardName: c.standardName,
				htmlTooltip: c.htmlTooltip,
				leftRight: 'l',
				//
				neutralProp: c.prop.substring(0, c.prop.length - 2),
				neutralLabel: c.label.substring(0, c.label.length - 2)
			}
			if (c.prop.endsWith('_r')) {
				col.leftRight = 'r';
				rightCols.push(col);
			} else {
				leftCols.push(col);
			}
			if (c.prop.includes(this.resoCenterService.fromAddrColCore)) {
				col.fromTo = 'from';
			} else if (c.prop.includes(this.resoCenterService.toAddrColCore)) {
				col.fromTo = 'to';
			}
		});
		return {
			leftCols: leftCols,
			rightCols: rightCols
		}
	}
	private resetMetrics() {
		this.metricsInfo = {
			leftCols: [],
			rightCols: [],
			props: {}
		};
	}
	private setMetricsValue() {
		this.metricsInfo.leftCols.forEach(c => {
			if (c.prop === this.attrIndexService.addrDensityLeftColName) {
				const info = this.resoCenterService.getRecordInfo(this.centerline.id);
				const density = this.resoCenterService.calcAddressDensity(this.centerline.props, info.geomLength);
				this.metricsInfo.props[this.attrIndexService.addrDensityLeftColName] = density.left;
				this.metricsInfo.props[this.attrIndexService.addrDensityRightColName] = density.right;
			}


		})
	}
	private checkDensityChange(changedCol: ResoCenterCol) {
		if (!changedCol) {
			return;
		}
		const recordInfo = this.resoCenterService.getRecordInfo(this.centerline.id);
		switch (changedCol.prop) {
			case this.attrIndexService.fromAddrLeftColName:
			case this.attrIndexService.toAddrLeftColName:
				const densityLeft = this.resoCenterService.calcAddressDensity(this.centerline.props, recordInfo.geomLength, 'left');
				this.metricsInfo.props[this.attrIndexService.addrDensityLeftColName] = densityLeft.left;
				break;
			case this.attrIndexService.fromAddrRightColName:
			case this.attrIndexService.toAddrRightColName:
				const densityRight = this.resoCenterService.calcAddressDensity(this.centerline.props, recordInfo.geomLength, 'right');
				this.metricsInfo.props[this.attrIndexService.addrDensityRightColName] = densityRight.right;
				break;
		}
	}

	ngOnInit() {
		this.resetMetrics();
		this.flipRoadSub = this.flipRoadService.flipRoadSubject.subscribe(data => {
			if (data && data.id && data.id !== this.centerline.id) {
				return;
			}
			if (data.geom) {
				this.isFlipRoadGeom = !this.isFlipRoadGeom;
			}
			this.onEditCell(null, true);
		});
	}
	async ngOnChanges(changes: SimpleChanges) {
		if (changes.resolverFeed) {
			console.log('On feed change, AOE')
			await this.onFeedChange();
		}
	}
	ngOnDestroy(): void {
		this.flipRoadSub.unsubscribe();
	}
}
